import React from 'react'

export type HistoryTagIconProps = {}

export const HistoryTagIcon: React.FC<HistoryTagIconProps> = () => {
  return (
    <svg
      width="359"
      height="55"
      viewBox="0 0 359 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3836 7.34636C12.5637 3.28985 16.2808 0.5 20.5055 0.5H348.676C355.007 0.5 359.567 6.57505 357.798 12.6536L347.616 47.6536C346.436 51.7102 342.719 54.5 338.495 54.5H10.3236C3.99306 54.5 -0.566531 48.425 1.20178 42.3464L11.3836 7.34636Z"
        fill="white"
        stroke="#9FA1FF"
      />
    </svg>
  )
}
